import React          from 'react';
import classNames     from 'classnames';
import * as PropTypes from 'prop-types';

export const RenderCheckbox = ({ ...props }) => {
  const {
          checked,
          count,
          disabled,
          label,
          onChange,
        } = props;

  return (
    <div
      className={classNames(
        'checkbox',
        { 'checked': checked, disabled },
      )}
    >
      <label>
        <input
          type={'checkbox'}
          checked={checked}
          disabled={disabled}
          onChange={event => {
            const { target: { value } } = event;

            if (typeof onChange === 'function') {
              onChange(value);
            }
          }}
        />
        <span className={'ic-check'} />
        <span className={'checkbox-label'}>{label}</span>
        {typeof count === 'number' && <span className={'facet-count'}>({count})</span>}
      </label>
    </div>
  );
};

RenderCheckbox.propTypes = {
  checked:  PropTypes.bool.isRequired,
  count:    PropTypes.number,
  disabled: PropTypes.bool,
  label:    PropTypes.string,
  onChange: PropTypes.func.isRequired,
};